export const API_URL = process.env.REACT_APP_API_URL;

// Типы данных для формы
export interface ContactFormData {
  name: string;
  email: string;
  message: string;
  contactMethod: string;
  contactValue: string;
  [key: string]: any; // Для дополнительных полей
}

// Типы для ответа сервера
export interface FormSubmitResponse {
  success: boolean;
  message?: string;
  error?: string;
}

/**
 * Отправляет данные формы на API
 * @param formData Данные формы для отправки
 * @param endpoint URL эндпоинта API
 * @returns Объект с результатом отправки
 */
export async function submitContactForm(
  formData: ContactFormData
): Promise<FormSubmitResponse> {
  const endpoint = `${API_URL}/form-submit`;
  try {
    // Подготовка данных с указанием названия формы
    const dataToSend = {
      ...formData,
      _form_name: "Контактная форма",
    };

    // Отправка запроса на сервер
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataToSend),
    });

    // Получение ответа в формате JSON
    const result = await response.json();

    if (response.ok && result.success) {
      // Успешная отправка
      return {
        success: true,
        message: result.message || "Форма успешно отправлена",
      };
    } else {
      // Ошибка от сервера
      return {
        success: false,
        error: result.error || "Произошла ошибка при отправке формы",
      };
    }
  } catch (error) {
    // Ошибка соединения или другие ошибки
    console.error("Error submitting form:", error);
    return {
      success: false,
      error: "Ошибка соединения с сервером. Пожалуйста, попробуйте позже.",
    };
  }
}
